/**
 * Configuración default de campaña de módulo
 * Será mergeada con deepmerge con campaña específica
 */
const legalesConsulta = `
Datos personales<br/>
Los datos personales aquí incluidos tienen el carácter de declaración jurada y son recogidos para ser incorporados y tratados en una base de datos, la cual se encuentra registrada en la Agencia de Acceso a la Información Pública, cuyo destinatario y titular es el Banco BBVA Argentina S.A. Cualquier falseamiento, error y/o inexactitud respecto a la información implicará la supresión de estos datos de la base de referencia y no podrán ser utilizados a futuro.<br/>
El usuario presta su consentimiento expreso al BBVA, para que toda la información referente a su persona, sus actividades económicas o las operaciones que haya concertado o que concierte en el futuro (en adelante y en su conjunto "la información") pueda ser transferida y cedida, aun en forma gratuita, dentro de estrictas políticas de confidencialidad y seguridad de los datos, a sus afiliadas, subsidiarias, controlantes, controladas y/o cualquier tercero. La información podrá ser utilizada para: a) La realización de segmentaciones o perfiles del Cliente, con fines comerciales a efectos de adaptar los productos o servicios a necesidades o características específicas, así como con fines de análisis de riesgos para evaluar nuevas operaciones, en ambos supuestos conservando dichas segmentaciones o perfiles en tanto y en cuanto el interviniente mantenga relación contractual con el BBVA, pudiendo oponerse en cualquier momento a dicho tratamiento; b) El envío a través de cualquier medio, por parte del BBVA de otros terceros, de ofertas comerciales, distintos tipos de informaciones o publicidades, personalizadas o no, sobre productos o servicios propios o de terceros; c) Para cualquier otra finalidad no incompatible con las especificadas anteriormente. Cuando así lo disponga, el usuario tendrá el derecho de acceder a la información y solicitar su rectificación o supresión de la base de archivo.<br/>
El BBVA informa al usuario que sus datos personales podrán ser cedidos a las autoridades competentes cuando las leyes o regulaciones de aplicación así lo establezcan.<br/>
En función del Estándar de la Organización para la Cooperación y Desarrollo Económicos (OCDE) para el Intercambio Automático de Información en Asuntos Fiscales y de las disposiciones de la Ley de cumplimiento fiscal de cuentas extranjeras (“Foreign Account Tax Compliance Act” - FATCA) de los Estados Unidos de América, el cliente autoriza al Banco a ceder información a autoridades de terceros países por operatorias desarrolladas en los mercados internacionales tales como Estados Unidos. Lo expuesto, ya sea de forma agregada o individual, según el caso.<br/>
El titular de los datos personales tiene el derecho de acceso a los mismos en forma gratuita en intervalos no inferiores a seis meses, salvo que se acredite un interés legítimo al efecto conforme lo establecido en el artículo 14, inciso 3 de la Ley 25.326.<br/>
La AGENCIA DE ACCESO A LA INFORMACIÓN PUBLICA, Órgano de Control de la Ley Nº 25.326, tiene la atribución de atender las denuncias y reclamos que se interpongan con relación al incumplimiento de las normas sobre protección de datos personales.<br/>
<br/>
Sistemas de Biometría:<br/>
En caso de que el BBVA defina el uso de dispositivos para la captura, lectura y/o procesamiento de datos –inclusive aquellos de carácter biométricos– en alguno de sus procesos operativos y/o de seguridad aplicables, el usuario autoriza al BBVA a compartir estos datos con terceros exclusivamente para el resguardo de la información capturada, la verificación de la identidad del titular de los datos y/o con los fines que el BBVA determine.<br/>
<br/>
Sistemas de información crediticia:<br/>
Ante la solicitud de cualquier producto, el BBVA puede solicitar información a las agencias de informes comerciales a fin de evaluar la situación crediticia del usuario.<br/>
El usuario acepta que estará sujeto a la clasificación e inclusión en la "Central de deudores del sistema financiero", de conformidad a la normativa vigente del B.C.R.A., dado que es obligación del BBVA informar, solamente, al Banco Central de la República Argentina todos los datos que éste le requiera o que pudiera requerirle en el futuro, relacionados con sus Clientes. No será responsabilidad del BBVA la utilización de la información del usuario por parte de terceros distintos al B.C.R.A., dado que la misma no es proporcionada por el Banco.<br/>
<br/>
<a href=" https://www.bbva.com.ar/tablas/tasaprestpers.pdf ">Conocé las tasas vigentes</a>`;
const legalesOferta = `
¿En qué consiste esta oferta?
<br/>
Esta oferta está dentro de Cartera de Consumo y está sujeta a la aprobación final del departamento de créditos del Banco BBVA Argentina S.A.
<br/>
<br/>
¿Cuál es la vigencia de esta oferta?
<br/>
Esta oferta es válida para el día de la fecha, para la República Argentina.
<br/>
<br/>
¿La cancelación anticipada tiene costo?
<br/>
Comisión por cancelación anticipada parcial: 4% + IVA.-.
Comisión por cancelación anticipada total:
<br/>
<dd>● Si han pasado 180 días o más desde el otorgamiento del préstamo o ha pasado una cuarta parte del plazo pactado, entre ambos el mayor: sin cargo </dd>
<dd>● Si es antes de 180 días o ha pasado menos de una cuarta parte del plazo pactado, de ambas condiciones la mayor: 4% + IVA </dd>
<br/>
¿De qué importe podes disponer on line?
<br/>
Podés obtener tu préstamo desde $1.000 y hasta $20.000.000 a través de la web del banco <a href="https://www.bbva.com.ar"> www.bbva.com.ar </a> o a través de BBVA móvil.
<br/>
<br/>
¿Cuándo tendrás disponible el dinero en tu cuenta?
<br/>
La acreditación del dinero en tu cuenta estará disponible de manera inmediata desde la aprobación del préstamo.
<br/>
<br/>
¿Qué pasa si dentro de los 10 días hábiles me arrepiento de haber contratado el préstamo?
<br/>
Si solicitaste tu préstamo de manera online, podrás cancelar la misma dentro de los 10 días hábiles, contados desde la fecha de acreditación del dinero, ingresando a <a href=" https://apps.bbva.com.ar/openmarket/cancelacion/#/ ">Botón de arrepentimiento</a>.
<br/>
<a href=" https://www.bbva.com.ar/tablas/tasaprestpers.pdf ">Conocé las tasas vigentes</a>`;
export default {
  googleAnalyticsId: null,
  modulo: "Préstamos personales",
  cantPasos: 8,
  isVeridasActive: true,
  pasos: {
    consulta: {
      path: "/",
      component: "components/views/Consulta",
      titulo: "Simulador de préstamos personales",
      subtitulo:
        "Te pedimos tus datos tal como figuran en tu DNI para ofrecerte un préstamo ideal para vos",
      card_titulo: "Simulador de préstamos",
      card_subtitulo:
        "En el paso siguiente, vas a poder calcular el valor aproximado de las cuotas según el monto del préstamo y el plazo de devolución que elijas.",
      footerText: legalesConsulta,
      footerTheme: "light",
      beneficios: {
        0: {
          icono: require("../../assets/img/icons-beneficios/clock.svg"),
          title: "Rápido",
          subtitle: "Lo tenés acreditado en minutos"
        },
        1: {
          icono: require("../../assets/img/icons-beneficios/devices.svg"),
          title: "100% online",
          subtitle: "Podés contratarlo sin ir a una sucursal"
        },
        2: {
          icono: require("../../assets/img/icons-beneficios/calendar.svg"),
          title: "Personalizado",
          subtitle: "Elegís el día de pago de tu cuota"
        },
        3: {
          icono: require("../../assets/img/icons-beneficios/flexible.svg"),
          title: "Flexible",
          subtitle: "Hasta 60 meses para financiar lo que necesites"
        }
      },
      textosPorExperiencia: {
        edad18_34: {
          titulo: "Un préstamo que crece con vos",
          subtitulo:
            "Vas a poder equipar tu hogar, tener tu primer auto o lo que tengas en mente. Completá tus datos tal como figuran en tu DNI. "
        },
        edad35_55: {
          titulo: "Un préstamo pensado para acompañarte",
          subtitulo: "Porque tus proyectos no tienen edad"
        },
        edad_55: {
          titulo: "Es hora de cumplir tu sueño pendiente",
          subtitulo: "Una oportunidad para disfrutar sin preocupaciones"
        }
      }
    },
    renaperConfirmar: {
      path: "/confirmar-datos",
      titulo: "Confirmá los datos",
      subtitulo:
        "Corroborá que estén correctos, de no ser así podés modificarlos.",
      component: "components/views/RenaperConfirmar",
      pasoSiguiente: "renaperConsultar",
      nombreSiguiente: "Confirmar",
      analyticsName: "confirmar datos",
      pasoAnterior: "consulta"
    },
    renaperConsultar: {
      path: "/confirmar-datos-renaper",
      titulo: "Por último, completá el número de trámite que figura en tu DNI",
      subtitulo:
        "Vamos a hacer una consulta al Registro Nacional de las Personas (RENAPER) para validar los datos.",
      component: "components/views/RenaperConsultar",
      analyticsName: "tramite dni",
      pasoAnterior: "renaperConfirmar"
    },
    oferta: {
      path: "/oferta",
      component: "components/views/Oferta",
      titulo: "Simulá tu préstamo",
      pasoAnterior: "consulta",
      subtitulo_00:
        "Calculá el valor aproximado de las cuotas antes de solicitarlo.",
      subtitulo_05:
        "Calculá el valor aproximado de las cuotas antes de solicitarlo. Vas a tenerlo disponible desde el comienzo del próximo día.",
      card: "La tasa de interés puede variar según la cantidad de meses que elijas.",
      help:
        "<p>TNA: Tasa Nominal Anual. Interés de referencia estimado en un año.</p>" +
        "<p>TEA: Tasa Efectiva Anual. Interés real que se aplicará a la operación.</p>" +
        "<p>CFT: Costo Financiero Total. Costo por la financiación.</p>" +
        '<p style="text-align: right;font-family: BentonSansBBVA-Medium;font-size: 15px;">',
      help2:
        "<p>Sistema de amortización francés: el valor de la cuota (sin IVA) se mantiene constante.</p>",
      footerText: legalesOferta,
      beneficiosTituloNoCliente: "Beneficios exclusivos si sos cliente",
      beneficiosTituloCliente: "Beneficios exclusivos",
      beneficiosItems: [
        {
          titulo: "Acreditación inmediata",
          subtitulo: "Validando tu identidad en el momento mediante biometría."
        },
        {
          titulo: "100% Online",
          subtitulo: "Podés contratarlo de manera online."
        },
        {
          titulo: "Gastos de otorgamiento",
          subtitulo: "0%. Sin costo adicional."
        }
      ],
      subtitulo:
        "Te pedimos un poco más de información para completar tu solicitud. ¡Ya falta poco!",
      pregunta: "¿Para qué usarías el préstamo?",
      pregunta2: "¿Qué día preferirías pagar la cuota?",
      help3:
        "<strong>Sugerencia</strong>" +
        "<p>Elegí un día en el que solés tener dinero disponible. Por ejemplo: después de cobrar tu ingreso principal.</p>",
      card2:
        "Si pasan más de 30 días antes de la fecha del 1° débito, el monto de las cuotas puede variar. Vas a encontrar el valor exacto en el resumen, antes de confirmar.",
      card_info:
        "Cuando el día elegido sea sábado, domingo o feriado, el débito se hará en el próximo día hábil."
    },
    landingQR: {
      path: "/landingQR",
      component: "components/views/CompruebaIdentidad",
      cliente: {
        titulo:
          "Para que puedas solicitar tu préstamo, necesitamos comprobar tu identidad",
        subtitulo:
          "Elegí un método para validar tu identidad. Este paso es necesario para proteger tus operaciones.",
        card_titulo: "Simulador de préstamos",
        items: [
          {
            titulo: "Con biometría, recibís tu préstamo al instante",
            subtitulo: "Escaneá el QR y seguí desde tu celular.",
            subtitulo2: "Vamos a necesitar unas selfies y unas fotos de tu DNI."
          },
          {
            titulo: "Con otro método, recibís tu préstamo en 48 horas",
            subtitulo: "Continuá desde la computadora. ",
            subtitulo2: "Validá tu identidad con código SMS o clave Token."
          }
        ]
      },
      noCliente: {
        titulo: "Seguí desde tu celular para</br> pedir tu préstamo online",
        subtitulo:
          "Necesitamos comprobar tu identidad antes de avanzar. Recordá que vas a</br> abrir una caja de ahorro gratuita en BBVA para recibir el dinero.",
        box_titulo: "<strong>Escaneá el QR o recibí un SMS</strong>",
        box_subtitulo: "Vamos a pedirte unas selfies y unas fotos de tu DNI."
      }
    },
    paso1: {
      paso: 1,
      path: "/datosPersonales",
      component: "components/views/DatosPersonales",
      titulo: "Datos personales",
      pasoAnterior: "oferta",
      pasoSiguiente: "paso2",
      subtitulo:
        "Necesitamos algunos datos personales para abrir tu caja de ahorro en BBVA."
    },
    paso2: {
      paso: 2,
      path: "/datosLaborales",
      component: "components/views/DatosLaborales",
      titulo: "Datos laborales",
      subtitulo:
        "Necesitamos algunos datos sobre tu situación laboral para continuar.",
      pasoAnterior: "paso1",
      pasoSiguiente: "paso3"
    },
    paso3: {
      paso: 3,
      path: "/informacionAdicional",
      component: "components/views/InformacionAdicional",
      askLeave: true,
      pasoSiguiente: "paso4",
      pasoAnterior: "paso2",
      titulo: "Información adicional",
      subtitulo:
        "Necesitamos esta información para abrir tu caja de ahorro en BBVA.",
      logoCobranding: false
    },
    paso4: {
      paso: 4,
      path: "/identidad",
      component: "components/views/Paso4",
      pasoSiguiente: "loadingVeridas",
      pasoAnterior: "paso3",
      titulo: "Validación de identidad",
      subtitulo:
        "Tené a mano tu DNI y seguí los pasos que te indicamos a continuación.",
      tituloModal: "Términos y Condiciones",
      condicionesTerminos:
        "Por medio del presente, en mi carácter de TÍTULAR DE LOS DATOS presto mi CONSENTIMIENTO para que BBVA en su carácter de CESIONARIO confronte mis datos personales que se indican en párrafo siguiente con la base de datos del RENAPER, conforme a las especificaciones que a continuación se detallan: DATOS AUTORIZADOS: El presente consentimiento para el tratamiento de mis datos personales alcanza a los incluidos en mi Documento Nacional de Identidad (INCLUYENDO DATOS BIOMÉTRICOS DE RECONOCIMIENTO FACIAL) en confronte con lo que informa el web service del REGISTRO NACIONAL DE LAS PERSONAS. INFORMACIÓN SOBRE EL TRATAMIENTO: 1. Los datos serán tratados con la exclusiva finalidad de validar mi identidad y verificar la vigencia de mi Documento Nacional de Identidad para realizar la generación y/o blanqueo de mis claves. 2. Los datos confrontados serán destruidos una vez verificada la validez del Documento Nacional de Identidad y validada la misma, no pudiendo ser almacenados. 3. Los datos son facilitados con carácter obligatorio, por cuanto es imprescindible identificar fehacientemente al titular, para asegurar el correcto proceso de identificación. 4. El titular de los datos podrá ejercer los derechos de acceso, rectificación y supresión de sus datos en cualquier momento y a su sola solicitud ante el RENAPER. 5. En cumplimiento de la Resolución AAIP Nº 14/2018, le hacemos saber que la AGENCIA DE ACCESO A LA INFORMACIÓN PÚBLICA, en su carácter de Órgano de Control de la Ley N° 25.326, tiene la atribución de atender las denuncias y reclamos que interpongan quienes resulten afectados en sus derechos por incumplimiento de las normas vigentes en materia de protección de datos personales."
    },
    entrega: {
      paso: 5,
      path: "/entrega",
      component: "components/views/EntregaTarjeta",
      askLeave: true,
      pasoAnterior: "biometriaOK",
      pasoSiguiente: "resumen",
      nombreSiguiente: "Continuar",
      antetitulo: null,
      titulo: "<strong>Ya casi terminamos</strong>",
      logoCobranding: false
    },
    resumen: {
      paso: 6,
      path: "/resumen",
      component: "components/views/Resumen",
      pasoAnterior: "entrega",
      pasoSiguiente: "contratos",
      nombreSiguiente: "Continuar",
      titulo: "Resumen",
      subtitulo: "Revisá que todos los datos sean correctos",
      items: [
        {
          m: "Monto",
          p: "Plazo",
          t: "TNA",
          c: "TEA",
          cft: "CFT",
          i: "Impuesto de sellos",
          c1: "1º cuota",
          c2: "2º cuota",
          d: "Día de pago"
        }
      ],
      card_titulo: "<strong>Caja de ahorro</strong>",
      card_subtitulo:
        "Esta solicitud incluye una <strong>caja de ahorro</strong> y una <strong>tarjeta de débito Visa </strong>sin costos de mantenimiento. En esa caja de ahorro vas a recibir tu préstamo y se van a debitar los pagos. La tarjeta se envía a tu domicilio.",
      card_text:
        "Comisión por cancelación total anticipada:</br> Antes de 180 días o una cuarta parte del  plazo</br> total del préstamo: 4% + IVA sobre el capital a</br> cancelar.</br> Después de 180 días o una cuarta parte del plazo</br> total del préstamo: sin costo adicional sobre el </br>capital a cancelar.</br> Comisión por cancelación parcial anticipada: 4%</br> + IVA sobre la cantidad cancelada.",
      contratos: "contratos"
    },
    contratos: {
      paso: 7,
      path: "/contratos",
      component: "components/views/Contratos",
      pasoAnterior: "resumen",
      pasoSiguiente: "gracias",
      titulo: "Contratos",
      subtitulo: "¡Último paso! Leé y aceptá los contratos de tus productos."
    },
    gracias: {
      path: "/gracias",
      component: "components/views/Gracias",
      pasoAnterior: "contratos",
      pasoSiguiente: "usuario",
      titulo_00:
        "¡Listo! Vas a tener tu préstamo personal en minutos y tu tarjeta de débito en unos días.",
      titulo_05:
        "¡Listo! Vas a tener tu préstamo personal desde el inicio del próximo día. Tu tarjeta de débito va a llegar en unos días.",
      paso1_00:
        "Acreditamos tu préstamo en tu caja de ahorro. Podés acceder a tu dinero desde Banca Online. Solo tenés que registrarte.",
      paso1_05:
        "Vamos a acreditar tu préstamo en tu caja de ahorro. Podés acceder a tu dinero desde Banca Online. Solo tenés que registrarte."
    },
    usuario: {
      paso: 8,
      path: "/usuario-y-clave",
      component: "components/views/CreacionUsuario",
      askLeave: true,
      pasoAnterior: "gracias",
      pasoSiguiente: "celular",
      antetitulo: null,
      titulo: "Creá tu usuario y clave digital",
      subtitulo:
        "Elegí el nombre de usuario y la clave digital que vas a utilizar para acceder a la banca online. <strong>Recordá no usar datos filiatorios ni de fácil deducción.</strong>"
    },
    celular: {
      paso: 9,
      path: "/celular",
      pasoAnterior: "usuario",
      pasoSiguiente: "final",
      component: "components/views/ValidacionCelular",
      askLeave: true,
      antetitulo: null,
      titulo: "Validá tu celular",
      subtitulo:
        "Escribí tu número de celular. Te vamos a enviar un SMS con un código de verificación."
    },
    final: {
      path: "/final",
      component: "components/views/Final"
    },
    mensaje: {
      path: "/mensaje/:mje",
      component: "components/views/Mensaje"
    },
    mensajeVeridas: {
      path: "/error-biometria/:mje",
      component: "components/views/MensajeVeridas"
    },
    loadingVeridas: {
      path: "/verificando-biometria",
      component: "components/views/LoadingVeridas",
      header: "Verificación de identidad",
      pasoSiguiente: "biometriaOK",
      askLeave: true,
      analyticsName: "verificando biometria",
      titulo: "Estamos validando tu identidad",
      subtitulo1: "Te pedimos que no actualices esta pantalla.",
      subtitulo2: "Mientras, te contamos cuales serán tus próximos pasos",
      pasos: [
        {
          text: "Completar y verificar tus datos de contacto."
        },
        {
          text: "Confirmar tu domicilio y el lugar de entrega de tus productos."
        },
        {
          text: "Leer y firmar tu contrato."
        }
      ]
    },
    biometriaOK: {
      path: "/biometria-ok",
      component: "components/views/OkVeridas",
      pasoSiguiente: "entrega",
      askLeave: true,
      analyticsName: "biometria-ok"
    },
    continuaSucursal: {
      path: "/error-continua-sucursal/:tipo",
      pasoAnterior: "consulta",
      component: "components/views/ContinuaSucursal",
      footerText: null
    }
  }
};
